import React from 'react';
import style from './StockImg.module.css';

const StockImg = ({ symbol, className, ...params }) => {
  return (
    <img src={`https://assets.parqet.com/logos/symbol/${symbol?.replace('.', '-')}`} onError={({ currentTarget }) => {
      currentTarget.onerror = null; // prevents looping
      currentTarget.src = '/react/phosphor/buildings-duotone.svg'
    }} className={style.stockImg + (className ? ` ${className}` : '')} {...params} />
  );
};

export default StockImg;
